import { StudentReviewAssignment } from "shared/types/science35Types"

export const isMastered = ({ pretestGrade, lessonGrade } : StudentReviewAssignment): boolean => {
    return pretestGrade >= 75 || lessonGrade >= 75
}

export const exceedsMastery = ({ pretestGrade, lessonGrade } : StudentReviewAssignment): boolean => {
    return pretestGrade >= 91 || lessonGrade >= 91
}
